import { useFlags } from "launchdarkly-react-client-sdk";
import { useEffect } from "react";

import { useAppDispatch } from "app/hooks";
import { BOOKING_DESK_FORM_FEATURE } from "constants/feature-flags";
import { setBookingDeskOffered } from "features/scheduling-v3/state/scheduler-v3.slice";

/**
 * Hands the `bookingDeskFormFeature` flag to Scheduling V3 (ENG-2218), which may not import
 * LaunchDarkly. Mounted in the app layout rather than on the V3 route, because the V3 form
 * also opens from a patient's chart. Until the flag is read it is `undefined`, which offers
 * nothing: the form is classic until the flag says otherwise.
 */
export function BookingDeskFlagSync() {
  const offered = useFlags()[BOOKING_DESK_FORM_FEATURE] === true;
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(setBookingDeskOffered(offered));
  }, [dispatch, offered]);
  return null;
}
